import { createActions, createReducer, resettableReducer } from 'reduxsauce';

export const INITIAL_STATE = {
  // --- Business signup (existing, untouched) ---
  fetching: false,
  fetched: false,
  values: {},
  errors: null,

  // --- Customer signup (ported from mobile, namespaced to avoid any
  // collision with the business signup fields above) ---
  customer: {
    fetching: false,
    fetched: false,
    values: {},
    errors: null,
    signupInProgress: false,
    signupCompleted: false,
    business: null,
    premiumSponsor: null,
  },
};

const { Types, Creators } = createActions(
  {
    reset: [],

    // Business signup (existing)
    signUp: ['formValues'],
    signUpRequest: ['formValues'],
    signUpSuccess: [],
    signUpFailure: ['errors'],

    // Customer signup (ported from mobile, prefixed with Customer)
    customerValidateCustomerInfo: ['formValues', 'resolve'],
    customerSaveCustomerInfo: ['customerInfoValues'],
    customerSignUp: ['formValues'],
    customerSignUpRequest: ['formValues'],
    customerSignUpSuccess: [],
    customerSignUpFailure: ['errors'],
    customerSetSignupProgress: ['status'],
    customerSetSignupCompleted: ['completed'],
    customerSetBusiness: ['business'],
    customerSetPremiumSponsor: ['premiumSponsor'],
  },
  { prefix: 'cb/signup/' },
);

export { Types as types, Creators as actions };

// --- Business signup reducers (existing, untouched) ---

export const signUpRequest = (state = INITIAL_STATE, action) => {
  const { formValues } = action;
  return {
    ...state,
    fetching: true,
    fetched: false,
    values: formValues,
    errors: null,
  };
};

export const signUpSuccess = (state = INITIAL_STATE) => {
  return {
    ...state,
    fetching: false,
    fetched: true,
    errors: null,
  };
};

export const signUpFailure = (state = INITIAL_STATE, action) => {
  const { errors } = action;
  return {
    ...state,
    fetching: false,
    fetched: true,
    errors,
  };
};

// --- Customer signup reducers (ported from mobile), all scoped to
// state.customer so they can never step on business signup state ---

export const customerSaveCustomerInfo = (state = INITIAL_STATE, action) => {
  const { customerInfoValues } = action;
  return {
    ...state,
    customer: {
      ...state.customer,
      values: {
        ...state.customer.values,
        ...customerInfoValues,
      },
    },
  };
};

export const customerSignUpRequest = (state = INITIAL_STATE, action) => {
  const { formValues } = action;
  return {
    ...state,
    customer: {
      ...state.customer,
      fetching: true,
      fetched: false,
      values: {
        ...state.customer.values,
        ...formValues,
      },
      errors: null,
    },
  };
};

export const customerSignUpSuccess = (state = INITIAL_STATE) => {
  return {
    ...state,
    customer: {
      ...state.customer,
      fetching: false,
      fetched: true,
      errors: null,
    },
  };
};

export const customerSignUpFailure = (state = INITIAL_STATE, action) => {
  const { errors } = action;
  return {
    ...state,
    customer: {
      ...state.customer,
      fetching: false,
      fetched: true,
      errors,
    },
  };
};

export const customerSetSignupProgress = (state = INITIAL_STATE, action) => {
  const { status } = action;
  return {
    ...state,
    customer: {
      ...state.customer,
      signupInProgress: status,
    },
  };
};

export const customerSetSignupCompleted = (state = INITIAL_STATE, action) => {
  const { completed } = action;
  return {
    ...state,
    customer: {
      ...state.customer,
      signupCompleted: completed,
    },
  };
};

export const customerSetBusiness = (state = INITIAL_STATE, action) => {
  const { business } = action;
  return {
    ...state,
    customer: {
      ...state.customer,
      business,
    },
  };
};

export const customerSetPremiumSponsor = (state = INITIAL_STATE, action) => {
  const { premiumSponsor } = action;
  return {
    ...state,
    customer: {
      ...state.customer,
      premiumSponsor,
    },
  };
};

export const HANDLERS = {
  [Types.SIGN_UP_REQUEST]: signUpRequest,
  [Types.SIGN_UP_SUCCESS]: signUpSuccess,
  [Types.SIGN_UP_FAILURE]: signUpFailure,

  [Types.CUSTOMER_SAVE_CUSTOMER_INFO]: customerSaveCustomerInfo,
  [Types.CUSTOMER_SIGN_UP_REQUEST]: customerSignUpRequest,
  [Types.CUSTOMER_SIGN_UP_SUCCESS]: customerSignUpSuccess,
  [Types.CUSTOMER_SIGN_UP_FAILURE]: customerSignUpFailure,
  [Types.CUSTOMER_SET_SIGNUP_PROGRESS]: customerSetSignupProgress,
  [Types.CUSTOMER_SET_SIGNUP_COMPLETED]: customerSetSignupCompleted,
  [Types.CUSTOMER_SET_BUSINESS]: customerSetBusiness,
  [Types.CUSTOMER_SET_PREMIUM_SPONSOR]: customerSetPremiumSponsor,
};

export default resettableReducer(Types.RESET)(
  createReducer(INITIAL_STATE, HANDLERS),
);